import React from "react";
import "./CourseGroupTable.css";
import { Course } from "./Course";
import * as t from "./types";

// this will be for example the "LittleTigers" group of courses
// there should be a big heading and a table with the given dates/days as headers.
// there will be a bool given for the days if they should be active or not
// inactve can be because the day is in the past, there is a holiday, or some special event like testing

interface CourseRowProps {
  name: string;
  courses: { [id: string]: t.ICourseData };
  days: string[];
  notifyUpdate: (data: t.IData) => void;
  backgroundColor: string;
}

const CourseRow = (props: CourseRowProps) => {
  // console.log("Rendering CourseRow");
  // console.log(props);
  const { name, courses, days, notifyUpdate, backgroundColor } = props;
  const styleDict = { backgroundColor: backgroundColor };
  return (
    <tr style={styleDict}>
      <th>{name}</th>
      {days.map((day) => {
        // console.log("day: ", day);
        // console.log(typeof day);
        // console.log(`courses[${day}]`);
        // console.log(courses[day]);
        // console.log("courses: ");
        // console.log(courses);
        return <Course courseData={courses[day]} notifyUpdate={notifyUpdate} />;
      })}
    </tr>
  );
};

interface CourseGroupTableProps {
  activeWeek: t.IWeek;
  courseGroup: t.ICourseGroup;
  notifyUpdate: (data: t.IData) => void;
}

export const CourseGroupTable = (props: CourseGroupTableProps) => {
  // console.log("CGT");
  // console.log(props);

  const { activeWeek, courseGroup, notifyUpdate } = props;
  // console.log(activeWeek);
  // console.log(courseGroup);

  const { name, courseRows } = courseGroup;
  // console.log(name, courseRows);

  const { days } = activeWeek;
  // console.log(days);

  const headerStyleDict = {
    backgroundColor: courseGroup.header_color,
    color: courseGroup.header_font_color || "black",
  };

  // console.log("hst: ");
  // console.log(headerStyleDict);

  return (
    <React.Fragment>
      <tr>
        <td colSpan={8}>
          <h3 className="course-group-header">{name}</h3>
        </td>
      </tr>
      <tr style={headerStyleDict}>
        <td></td>
        {days.map((day) => {
          return <td>{day}</td>;
        })}
      </tr>
      {courseRows.map((courseRow) => {
        return (
          <CourseRow
            name={courseRow.name}
            courses={courseRow.courses}
            days={days}
            notifyUpdate={notifyUpdate}
            backgroundColor={courseGroup.body_color}
          />
        );
      })}
    </React.Fragment>
  );
};
